import React from "react";
import { components } from "../../design/tokens";

interface ButtonProps {
  icon: React.ReactNode | null;
  label: string;
  onClick: () => void;
  align?: "left" | "center";
  disabled?: boolean;
  hideLabelOnMd?: boolean;
}

interface ButtonComponentProps extends ButtonProps {
  variant: "primary" | "secondary";
}

function Button({
  icon,
  label,
  onClick,
  align = "center",
  variant = "secondary",
  disabled = false,
  hideLabelOnMd = false,
}: ButtonComponentProps) {
  // Use design tokens for base styles
  const baseStyles = variant === "primary"
    ? components.button.primary
    : components.button.secondary;

  // Add w-full and alignment override (component-level exception, not in tokens)
  const finalClasses = `${baseStyles} w-full ${align === "left" ? "!justify-start" : ""}`;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={finalClasses}
    >
      {icon}
      <span className={hideLabelOnMd ? "hidden md:inline" : ""}>{label}</span>
    </button>
  );
}

export function PrimaryButton(props: ButtonProps) {
  return <Button {...props} variant="primary" />;
}

export function SecondaryButton(props: ButtonProps) {
  return <Button {...props} variant="secondary" />;
}
